/* eslint-disable */
import throwI18nInvalidLocaleTypeError from '../../../Errors/I18n/I18nInvalidLocale.error';
import isObject from '../../Is/Object/IsObject.support';
import i18nValidateDirection from '../ValidateDirection/I18nValidateDirection.support';
import i18nValidateLabel from '../ValidateLabel/I18nValidateLabel.support';
import i18nValidateLang from '../ValidateLang/I18nValidateLang.support';
import i18nValidateShortLabel from '../ValidateShortLabel/I18nValidateShortLabel.support';

/**
 * Determine if a provided `locale` is indeed a valid `locale`
 * @export
 * @param {any} locale The `locale` to check
 * @param {string} ltr The `ltr` value
 * @param {string} rtl The `rtl` value
 * @returns {boolean} Whether or not the provided `locale` is indeed valid
 */
const i18nValidateLocale = (locale, ltr, rtl) => {
  if (!isObject(locale)) {
    return throwI18nInvalidLocaleTypeError(locale, ltr, rtl);
  }
  const { direction, label, lang, shortLabel } = locale;
  i18nValidateDirection(direction, ltr, rtl);
  i18nValidateLabel(label);
  i18nValidateLang(lang);
  i18nValidateShortLabel(shortLabel);
  return true;
};

export default i18nValidateLocale;
